import React from "react";
import styles from "./videoCaption.module.css";
import { useWizardContextState } from "../../../context/wizardContext.js";
import {
  cupSmallCorrectFitCaptions,
  cupLargeCorrectFitCaptions,
  bandCorrectFitCaptions,
  bandTooBigCaptions,
  strapsCorrectFitCaptions,
  strapsTooBigCaptions,
} from "../../../constants/videoCaptionsCopy.js";

export const VideoCaption = (props) => {
  const { cup, selectedCropTopSize } = useWizardContextState();
  const { currentTick, braPart } = props;

  function getVideoCaption(copy, tick) {
    if (!copy?.labels?.length) return null;

    for (let i = 0; i < copy.labels.length; i++) {
      if (tick < copy.labels[i].tick) {
        return <div className={styles.videoCaption}>{copy.labels[i].copy}</div>;
      }
    }
    return null;
  }

  if (braPart === "Cup") {
    return cup < "D" || ["XS", "S", "M"].includes(selectedCropTopSize)
      ? getVideoCaption(cupSmallCorrectFitCaptions, currentTick)
      : getVideoCaption(cupLargeCorrectFitCaptions, currentTick);
  }

  if (braPart === "BandCorrect") {
    return getVideoCaption(bandCorrectFitCaptions, currentTick);
  }

  if (braPart === "BandIncorrect") {
    return getVideoCaption(bandTooBigCaptions, currentTick);
  }

  if (braPart === "StrapsCorrect") {
    return getVideoCaption(strapsCorrectFitCaptions, currentTick);
  }

  if (braPart === "StrapsIncorrect") {
    return getVideoCaption(strapsTooBigCaptions, currentTick);
  }

  return null;
};

export default VideoCaption;
